export const LISTINGS_LIMIT = 12;
export const LISTINGS_GRID_LIMIT = 30;
export const CSP_BUMP_LISTING_LIMIT = 2;
export const SPONSORED_LISTINGS_LIMIT = 2;

export const SHOW_FEATURED_IN_COLLECTION_LIMIT = 6;

// fixed cutoff at which point we render a 'view more'
// we have a general sense of how tall listing cards are
// so this suffices and keeps us from having to do
// dynamic height detection within TruncationContainer
export const LISTING_TRUNCATION_THRESHOLD = 6;
export const LISTING_TRUNCATION_REM_HEIGHT = 80;
export const GRID_EXP_LISTING_TRUNCATION_REM_HEIGHT = 160;

export const ALL_TOGETHER = 'allListings';
export const ALL_BUMPED = 'allBumped';

export const LAYOUT_QUERY_NAME = 'layoutData';
export const FILTERS_AND_LISTINGS_QUERY_NAME = 'filtersAndListingsData';

export const FRETBOARD_MATERIAL_TRAIT_UUID = '6a24e2dc-800d-4f06-ac67-acef9569a40f';

